import { ReactNode } from 'react';
import { SoftAlertType } from './types';
import { RU_MODE, SLON_MODE } from '@/configs/dybr';
import { useLocation } from 'react-router-dom';

interface SystemMessage {
  id: string;
  content: ReactNode;
  type: SoftAlertType;
  duration: number;
}

type ShowAlertFn = (
  message: string | ReactNode,
  type?: SoftAlertType,
  duration?: number,
  systemType?: string
) => number;

const isRussianLocation = RU_MODE || SLON_MODE;

const TimeoutMessage = () => {
  if (isRussianLocation) {
    const location = useLocation();
    return (
      <>
        <p>Не удалось получить ответ от сервера. Проверьте интернет-соединение. </p>
        <p style={{ paddingTop: '5px' }}>
          В некоторых регионах доступ может быть ограничен, попробуйте использовать VPN или перейти на{' '}
          <a
            href={'https://dybr.ru' + location.pathname}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => window.umami?.track('timeout-error-dybr_ru-click')}
          >
            https://dybr.ru
          </a>
        </p>
      </>
    );
  }

  return <>Не удалось получить ответ от сервера. Проверьте интернет-соединение.</>;
};

const SYSTEM_MESSAGES: Record<string, SystemMessage> = {
  TIMEOUT_ERROR: {
    id: 'timeout-error',
    content: <TimeoutMessage />,
    type: SoftAlertType.error,
    duration: 60000
  }
};

export const createSystemAlertFactory = (showAlert: ShowAlertFn) => ({
  showTimeoutError: () => {
    const message = SYSTEM_MESSAGES.TIMEOUT_ERROR;
    return showAlert(message.content, message.type, message.duration, message.id);
  }
});
